// src/App.jsx
import React from 'react';
import { BrowserRouter}  from 'react-router-dom';
import  {Link, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Testimonials from './components/Testimonial';
import HowItWorks from './components/HowItWorks';
import Creator from './components/Creator';
import Features from './components/Features';
import Community from './components/Community';
import InstallCTA from './components/InstallCTA';
import Footer from './components/Footer';
import PrivacyPolicy from './components/privacy';
import Legal from './components/Legal';
import Success from './components/Success';
import Cancel from './components/Cancel';
import Guide from './components/Guide';
import AdLanding from './components/AdLanding';

// Standalone ad landing pages skip the site's nav/footer chrome so there's
// nothing pulling paid traffic away from the single install CTA.
const STANDALONE_ROUTES = ['/get-shepherd'];

function AppShell() {
  const location = useLocation();
  const isStandalone = STANDALONE_ROUTES.includes(location.pathname);

  return (
    <>
      {!isStandalone && <Navbar />}
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <Testimonials />
            <Creator />
            <HowItWorks />
          </>
        } />

        <Route path="/legal" element={<Legal />} />
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/guide/:id" element={<Guide />} />
        <Route path="/get-shepherd" element={<AdLanding />} />
      </Routes>
      {!isStandalone && <InstallCTA />}
      {!isStandalone && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
